import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Lynn & Liana Designs (b_16l4jf5hzo, advertiser -4844530013728560382).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (lifetime totals over the 10
// complete months Nov 2025 – Aug 2026). Monthly series + partial Sep 2026 live
// in realBrandData.ts.
//
// A resin-and-stoneware homeware brand out of Steinbach, Manitoba: Top Shop,
// 1,001 stockists, and the smallest real program in this fork at ~$20k spend
// returning ~$120k of booked sales. POOLED on a $3,000 monthly pool,
// spending_mode MAXIMUM. Both campaigns report RUNNING since Jul 14 2026 even
// though CAMPAIGN_PERIODS carries them from Nov 2025, so the platform dates
// describe the current campaign records rather than the program's real start.
//
// Flagged `limited_20_30` — and Jun/Jul 2026 spend ($3,350 and $3,500) runs
// past the $3,000 pool, so the pool was almost certainly higher then and has
// since been cut. ADVERTISERS only reports today's figure, hence budget-capped.
//
// CAMPAIGN_PERIODS attributes no acquired-customer sales to reorder, so reorder
// salesDollars is TOTAL_LOCAL_POST_DISCOUNT.
export const advLynnLiana: FaireAdvertiserProfileEntity = {
  token: "adv_lynn_liana",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Lynn & Liana Designs",
  brandToken: "b_16l4jf5hzo",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 11,
  budget: {
    totalBudgetDollars: 3000,
    sharedBudgetDollars: 3000,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 112,
    numReorderConversions: 99,
    numTotalConversions: 211,
    totalAdsSalesDollars: 119974,
    newCustomerAdsSalesDollars: 56423,
    reorderAdsSalesDollars: 63551,
    totalAdsSpendDollars: 20226,
    newCustomerAdsSpendDollars: 15102,
    reorderAdsSpendDollars: 5124,
    newCustomerBestEstimateFirstYearRoas: 6.78,
    reorderRoas: 12.4,
    combinedFirstYearRoas: 8.21,
    numNewCustomerAdsOrders: 199,
    numReorderAdsOrders: 133,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 2400,
      maxRecommendedBudgetDollars: 4400,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 790,
      maxRecommendedBudgetDollars: 1580,
    },
  },
  campaignTokens: ["camp_ll_new", "camp_ll_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
